import React from "react";

interface UserManagementHeaderProps {
  onCreateNew: () => void;
}

const UserManagementHeader: React.FC<UserManagementHeaderProps> = ({
  onCreateNew,
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-6 gap-4 lg:gap-0">
      <div className="flex-1 min-w-0">
        <h1 className="text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-2 break-words">
          Quản lý Người dùng
        </h1>
        <p className="text-gray-600 dark:text-gray-300 break-words">
          Quản lý thông tin người dùng và phân quyền hệ thống
        </p>
      </div>
      <div className="flex-shrink-0">
        <button
          onClick={onCreateNew}
          className="w-full lg:w-auto bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 dark:hover:bg-blue-500 transition-colors"
        >
          + Thêm người dùng mới
        </button>
      </div>
    </div>
  );
};

export default UserManagementHeader;
